import { FadeIn } from './fade-in';

import { cn } from '~/lib/utils';

interface ProductOverviewSectionProps {
  title: string;
  description: string;
  sectionClassName?: string;
  contentClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export const ProductOverviewSection = ({
  title,
  description,
  sectionClassName,
  contentClassName,
  titleClassName,
  descriptionClassName,
}: ProductOverviewSectionProps) => {
  return (
    <section
      className={cn(
        'relative w-full bg-slate-900 px-4 md:px-20 pt-10 pb-20 md:py-[100px]',
        sectionClassName
      )}
    >
      <div className={cn('flex flex-col gap-5 w-full', contentClassName)}>
        <FadeIn>
          <p
            className={cn(
              "font-['Fragment_Mono','Fragment_Mono_Fallback',monospace] text-sm leading-normal text-white tracking-[0.14px] uppercase",
              titleClassName
            )}
          >
            {title}
          </p>
        </FadeIn>
        <FadeIn delay={0.15}>
          <p
            className={cn(
              'text-2xl md:text-[30px] text-white font-normal leading-normal',
              descriptionClassName
            )}
          >
            {description}
          </p>
        </FadeIn>
      </div>
    </section>
  );
};
